$(document).ready(function () { 
  var quickview = $('.quickview');

  var main_image=$('#productModal .modal-body .product-images .main-image img'),

      main_href=$('#productModal .modal-body .product-images .main-image a'),

      other_image=$('#productModal .modal-body .product-images .other-image  ul'),

      rating=$('#productModal .modal-body .product-desc .rating'),

      modal_title=$('#productModal .modal-body .product-info h2'),

      price=$('#productModal .modal-body .product-info .price-box .price'),

      modal_desc=$('#productModal .modal-body .product-info .quick-desc'),

      main_desc_href=$('#productModal .modal-body .product-info .see-all'),

      share=$('#productModal .modal-body .product-info .social-sharing'),

      btn_add=$('#productModal .modal-body .product-info .quick-add-to-cart .single_add_to_cart_button');

  var field_add=$('#productModal .modal-body .product-info .quick-add-to-cart #id'),

      btn_compare=$('#productModal .modal-body .product-info .button-group .btn-compare'),

      btn_wishlist=$('#productModal .modal-body .product-info .button-group .btn-wishlist'); 		

  $('body').on('click', '.quickview', function (){
    other_image.empty();

    rating.empty();

    price.empty();

    var product_info=$(this).data('productinfo');		
    main_image.attr('src',(product_info['images'] || [])[0] || '').attr('alt', product_info['title'] || '');

    main_href.attr('href','/products/'+product_info['handle']);

    main_desc_href.attr('href','/products/'+product_info['handle']);

    var arr_image=product_info['images'] || [];

    for(var i=0;i<arr_image.length&&i<3;i++){ 			

      other_image.append('<li><img style="width:78px;cursor:pointer" class="img-thumbnail other-image" src="'+arr_image[i]+'"></li>')
    }

    $('.other-image').click(function(){
      main_image.attr('src',$(this).attr('src'));
    });

    modal_title.text(product_info['title'] || '');

    var desc = product_info['description'] || '';
    var res = $('<div>').html(desc).text().trim();
    modal_desc.text(res.substring(0, 150));
    rating.append('<span class="shopify-product-reviews-badge" data-id="'+ product_info["id"] +'"></span>');

    var variants = product_info['variants'] || [];
    var selectedVariant = variants.find(function (variant) { return variant.available; });
    var displayVariant = selectedVariant || variants[0];
    var canAdd = product_info['available'] !== false && !!selectedVariant;
    var variantUrl = '/products/' + product_info['handle'];
    if (displayVariant) variantUrl += '?variant=' + displayVariant.id;
    main_href.attr('href', variantUrl);
    main_desc_href.attr('href', variantUrl);

    var format = moneyFormat;
    if (typeof Currency !== 'undefined' && Currency.moneyFormats && Currency.moneyFormats[shopCurrency]) {
      format = Currency.moneyFormats[shopCurrency].money_format;
    }
    if (displayVariant && typeof displayVariant.price === 'number') {
      price.append($('<span>').addClass('new-price').append(
        $('<span>').addClass('money').html(Shopify.formatMoney(displayVariant.price, format))
      ));
      if (displayVariant.compare_at_price > displayVariant.price) {
        price.append($('<span>').addClass('old-price').append(
          $('<span>').addClass('money').html(Shopify.formatMoney(displayVariant.compare_at_price, format))
        ));
      }
    }
    if (typeof Currency !== 'undefined' && Currency.cookie && typeof Currency.cookie.read === 'function' && typeof Currency.convertAll === 'function') {
      var selectedCurrency = Currency.cookie.read();
      if (selectedCurrency) Currency.convertAll(shopCurrency, selectedCurrency);
    }

    field_add.val(selectedVariant ? selectedVariant.id : '');
    btn_add.removeClass('btn disabled').removeAttr('onclick').prop('disabled', !canAdd);
    btn_add.text(btn_add.attr(canAdd ? 'data-add-label' : 'data-sold-label'));
    $('#productModal input[name="quantity"]').val(1);

    btn_compare.attr('onclick','compare.add('+product_info["product_id"]+')');
    btn_wishlist.attr('onclick','wishlish.add('+product_info["product_id"]+')');

  });
});
